import React, { useState } from 'react';
import Formulario from 'components/public/Formulario/Formulario';
import { datosFormBoletin } from 'utils/formData';
import { IFormulario, IFile, IBoletin } from 'utils/models/interfaces';
import { useError } from 'services/ErrorContext';
import { registroBoletin } from 'services/servicioPost';
import { StickyNote2Outlined } from '@mui/icons-material';
import DashboardContainer from 'components/PageContainer/DashboardContainer';
import { Box } from '@mui/material';
import { anchoMaxLogueado } from 'utils/constants';

const Boletin = () => {
  const [mensajeExito, setMensajeExito] = useState('');
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario = usuarioJSON && JSON.parse(usuarioJSON);
  const { error, setError, clearError, loading, setLoading } = useError();

  const handleSubmit = async (data: IFormulario) => {
    clearError();

    // @ts-expect-error -- form field typed by react-hook-form, not in interface
    const imagen: IFile = data?.Imagen[0];

    const requestBoletin: IBoletin = {
      Asunto: data.Asunto,
      Titulo: data.Titulo,
      Body: data.Body,
      Imagen: imagen,
      IdUsuarioEnviador: usuario.Id,
    };

    try {
      // Formdata = true para que envíe con headers de tipo form-data
      await registroBoletin(requestBoletin, setError, setLoading, true);
      setMensajeExito('¡El boletín fue enviado con éxito!');
    } catch (err) {
    }
  };

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <DashboardContainer>
      <Box maxWidth={anchoMaxLogueado} mx="auto">
        <Formulario
          campos={datosFormBoletin}
          titulo="Envío de boletín"
          anchoMax={600}
          onSubmit={handleSubmit}
          mensajeExito={mensajeExito}
          mensajeError={error}
          loading={loading}
          onVolver={handleVolver}
          iconoBoton={StickyNote2Outlined}
          textoBoton="Enviar boletín"
        />
      </Box>
    </DashboardContainer>
  );
};

export default Boletin;
